module.exports = __webpack_public_path__ + "img/clock.45f8ac6c.svg";